import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { Mail } from "lucide-react";

export default function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const subscribe = async () => {
    if (!email.includes("@")) return;
    setLoading(true);
    const { data: { user } } = await supabase.auth.getUser();
    const { error } = await supabase.from("newsletter_subscribers").insert({ email, user_id: user?.id ?? null });
    setLoading(false);
    if (error) {
      if (error.code === "23505") toast({ title: "Already subscribed", description: "This email is already on the list." });
      else toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Subscribed!", description: "Thanks for joining our newsletter." });
      setEmail("");
    }
  };

  return (
    <div className="flex flex-col sm:flex-row gap-2 max-w-md">
      <div className="relative flex-1">
        <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input type="email" placeholder="Your email" value={email} onChange={(e) => setEmail(e.target.value)} className="pl-9" />
      </div>
      <Button onClick={subscribe} disabled={loading}>Subscribe</Button>
    </div>
  );
}
